<template>
  <div style="height: 100%;background-color: #fbfbfb;padding-top: 20px;box-sizing: border-box">
<!--    <div style="height: 50px;margin: 0 20px">-->
<!--      <el-button type="primary" plain icon="el-icon-plus" @click="add()">新增</el-button>&nbsp;-->
<!--    </div>-->
    <div style="height: calc(100% - 20px);overflow-y: auto;margin: 0 20px">
      <el-table :data="tableData" v-loading="loading" height="100%" element-loading-text="加载中，请耐心等待。"
                border style="width: 100%" highlight-current-row ref="singleTable">
        <el-table-column
          type="index"
          label="序号"
          width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop="person_name"
          label="姓名"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          label="性别"
          min-width="100"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.person_sex === '0'">女</span>
            <span v-if="scope.row.person_sex === '1'">男</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="person_birthday"
          label="生日"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="person_phone"
          label="手机号码"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          label="邀请方式"
          min-width="80"
          align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.invite_channel === 'WX'">微信</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="create_tm"
          label="邀请时间"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="chird_register_tm"
          label="注册时间"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="supplier_person_name"
          label="邀请人"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop="supplier_person_phone"
          label="邀请号码"
          min-width="80"
          align="center">
        </el-table-column>
<!--        <el-table-column align="center" label="操作" width="140">-->
<!--          <template slot-scope="scope">-->
<!--            <i title="更新" class="el-icon-edit" style="cursor: pointer; font-size: 18px;color: #1ae517" @click="edit(scope.row)"></i>-->
<!--            <i title="删除" class="el-icon-delete" style="cursor: pointer; font-size: 18px;color: red" @click="del(scope.row)"></i>-->
<!--          </template>-->
<!--        </el-table-column>-->
      </el-table>
    </div>
<!--    <div style="margin-top: 10px;height: 40px;text-align: center">-->
<!--      <el-pagination v-fixZoom-->
<!--                     @size-change="handleSizeChange"-->
<!--                     @current-change="handleCurrentChange"-->
<!--                     :current-page="currentPage"-->
<!--                     :page-sizes="[10, 20, 50, 100]"-->
<!--                     :page-size="pageSize"-->
<!--                     layout="total, sizes, prev, pager, next, jumper"-->
<!--                     :total="totalCells">-->
<!--      </el-pagination>-->
<!--    </div>-->
    <el-dialog :visible.sync="addEditShow" v-if="addEditShow" width="500px" :show-close="true" :close-on-click-modal="false" center class="all-open">
      <div class="title-top-alarm">
        <div> <span>{{ addEditTitle }}</span> </div>
        <div class="line-title"></div>
      </div>
      <add-edit-user :addEditRow="addEditRow" v-model="addEditShow" @changeData="changeData"></add-edit-user>
    </el-dialog>
  </div>
</template>

<script>
import addEditUser from './businessComponents/addEditUser.vue'
import {queryminiinvite} from '../../api/project'
export default {
  name: 'userManagement',
  components: {addEditUser},
  data () {
    return {
      loading: false,
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      addEditShow: false,
      addEditTitle: '',
      addEditRow: {
        isAdd: true,
        row: ''
      }
    }
  },
  created () {
    this.getTableData()
  },
  methods: {
    changeData () {},
    getTableData () {
      queryminiinvite().then(res => {
        this.tableData = res.data.invites
      }).catch(() => {})
    },
    add () {
      this.addEditTitle = '新增用户'
      this.addEditShow = true
      this.addEditRow.isAdd = true
    },
    edit (row) {
      this.addEditTitle = '编辑用户'
      this.addEditShow = true
      this.addEditRow.isAdd = false
      this.addEditRow.row = row
    },
    del (row) {
      let name = row.username
      this.$confirm('此操作将永久删除该用户【' + name + '】, 是否继续?', '提示', {
        confirmButtonText: '确定', cancelButtonText: '取消', type: 'error'
      }).then(() => {
      }).catch(() => {})
    },
    // 页码
    handleSizeChange (val) {
      this.pageSize = val
      // this.getTableData()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      // this.getTableData()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/businessWeChat/userManagement.vue